import AuthorizationMiddleware from "@/middlewares/AuthorizationMiddleware";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      sidebarIcon: "@/assets/img/sidebar/Benutzer.png",
    },
    component: () =>
      import(/* webpackChunkName: "user_list" */ "@/views/users/UserView.vue"),
    children: [
      {
        path: "",
        name: "UserList",
        component: () =>
          import(
            /* webpackChunkName: "user-list" */ "../../views/users/UserList.vue"
          ),
        meta: {
          title: "general.user",
          roles: ["ROLE_SUPER_ADMIN"],
          middleware: [AuthorizationMiddleware],
          breadcrumbs: [
            { name: "Home", label: "route.home" },
            {
              name: "UserList",
              label: "general.user",
            },
          ],
        },
      },
      {
        path: "create",
        name: "UserAdd",
        component: () =>
          import(
            /* webpackChunkName: "user-add" */ "../../views/users/UserAdd.vue"
          ),
        meta: {
          title: "route.user_add",
          roles: ["ROLE_SUPER_ADMIN"],
          middleware: [AuthorizationMiddleware],
          breadcrumbs: [
            { name: "Home", label: "route.home" },
            {
              name: "UserList",
              label: "general.user",
            },
            {
              name: "UserAdd",
              label: "route.user_add",
            },
          ],
        },
      },
      {
        path: "edit/:id",
        name: "UserEdit",
        component: () =>
          import(
            /* webpackChunkName: "user-edit" */ "../../views/users/UserEdit.vue"
          ),
        meta: {
          title: "route.user_edit",
          roles: ["ROLE_SUPER_ADMIN"],
          middleware: [AuthorizationMiddleware],
          breadcrumbs: [
            { name: "Home", label: "route.home" },
            {
              name: "UserList",
              label: "general.user",
            },
            {
              name: "UserAdd",
              label: "route.user_edit",
            },
          ],
        },
      },
      {
        path: "profile",
        name: "UserProfile",
        component: () =>
          import(
            /* webpackChunkName: "user-profile" */ "../../views/users/UserProfile.vue"
          ),
        meta: {
          title: "route.user_edit",
          roles: ["ROLE_SUPER_ADMIN"],
          middleware: [AuthorizationMiddleware],
          breadcrumbs: [
            { name: "Home", label: "route.home" },
            {
              name: "UserProfile",
              label: "general.user_profile",
            },
          ],
        },
      },
    ],
  },
];
